import { render, staticRenderFns } from "./InvitationMerchantCreateAccount.vue?vue&type=template&id=5940e92a&scoped=true&"
import script from "./InvitationMerchantCreateAccount.vue?vue&type=script&lang=ts&"
export * from "./InvitationMerchantCreateAccount.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationMerchantCreateAccount.vue?vue&type=style&index=0&id=5940e92a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940e92a",
  null
  
)

export default component.exports